<de-loader  *ngIf="isLoadingValue" [showOverlay]="true" [zIndex]="100"></de-loader>